module.exports = __webpack_public_path__ + "img/ds-2.311ca1a8.png";